import { GridFourIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Dashboard = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <GridFourIcon size={Sizes[size]} {...rest} color={fill} />;
};

Dashboard.displayName = 'Dashboard';
